import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../elements/ButtonComponent";
import { axiosPrivate } from "../../api/axios";
import {
  PASSWORD_SETTER_URL,
  USER_HOME_CONTEXT,
  FORGET_CHANGE_PASSWORD,
} from "../../api/apiClient";

const NewPasswordSetter = ({
  isForgetPassword,
  goToMainLoginModal,
  closeModalNotSetPassword,
  navigateHere,
  closeModal,
  otp_ticket,
  setEnteredUser,
}: any) => {
  const [moreThan8, setMoreThan8] = useState("");
  const [upperAndLower, setUpperAndLower] = useState("");
  const [oneNumberOrMore, setOneNumberOrMore] = useState("");
  const [oneOrMoreSpechialChar, setOneOrMoreSpechelChar] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [passwordConfShow, setPasswordConfShow] = useState(false);
  const navigate = useNavigate();
  interface FormValues {
    password: string;
    confirmPassword: string;
  }
  const passwordStepperForm = useForm<FormValues>({
    mode: "onChange",
  });

  const {
    watch,
    handleSubmit,
    formState: { dirtyFields },
  } = passwordStepperForm;

  const watchedPassword = watch("password");
  const watchedConfirmPassword = watch("confirmPassword");
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    watch((value: any) => {
      const validMoreThan8 = /^.{8,}$/.test(value.password);
      const validUpperAndLower = /^(?=.*[a-z])(?=.*[A-Z]).*$/.test(
        value.password
      );
      const validOneNumberOrMore = /^(?=.*[0-9]).+$/.test(value.password);
      const validOneOrMoreSpecialChar = /^(?=.*[!@#$%]).+$/.test(
        value.password
      );

      setMoreThan8(validMoreThan8 ? " text-green-500" : " text-red-500");
      setUpperAndLower(
        validUpperAndLower ? " text-green-500" : " text-red-500"
      );
      setOneNumberOrMore(
        validOneNumberOrMore ? " text-green-500" : " text-red-500"
      );
      setOneOrMoreSpechelChar(
        validOneOrMoreSpecialChar ? " text-green-500" : " text-red-500"
      );

      setIsPasswordValid(
        validMoreThan8 &&
          validUpperAndLower &&
          validOneNumberOrMore &&
          validOneOrMoreSpecialChar
      );
    });
  }, [watchedPassword]);

  const getPasswordClass = () => {
    const base = `flex pt-3 pb-3 pr-4 pl-4 content-end items-center gap-2.5 self-stretch rounded-lg border border-solid border-gray-300 bg-gray-50`;

    if (passwordStepperForm.formState.errors.password !== undefined) {
      return `border-red-500 bg-red-50 ${base}`;
    } else if (
      passwordStepperForm.formState.errors.password === undefined &&
      dirtyFields.password === true
    ) {
      return `border-green-500 bg-green-50 ${base}`;
    } else {
      return base;
    }
  };

  const getPasswordTextClass = () => {
    const base = ` outline-none focus:border-gray-50 bg-gray-50 w-full text-Body-OneLine/14/Regular`;
    if (passwordStepperForm.formState.errors.password !== undefined) {
      return `text-red-700 bg-red-50 focus:border-red-50 ${base}`;
    } else if (
      passwordStepperForm.formState.errors.password === undefined &&
      dirtyFields.password === true
    ) {
      return `text-green-500 bg-green-50 focus:border-green-50 ${base}`;
    } else {
      return base;
    }
  };

  const getConfirmPasswordClass = () => {
    const base = `flex pt-3 pb-3 pr-4 pl-4 content-end items-center gap-2.5 self-stretch rounded-lg border border-solid border-gray-300 bg-gray-50`;

    if (passwordStepperForm.formState.errors.confirmPassword !== undefined) {
      return `border-red-500 bg-red-50 ${base}`;
    } else if (
      passwordStepperForm.formState.errors.confirmPassword === undefined &&
      dirtyFields.confirmPassword === true
    ) {
      return `border-green-500 bg-green-50 ${base}`;
    } else {
      return base;
    }
  };

  const getConfirmPasswordTextClass = () => {
    const base = ` outline-none focus:border-gray-50 bg-gray-50 w-full text-Body-OneLine/14/Regular`;
    if (passwordStepperForm.formState.errors.confirmPassword !== undefined) {
      return `text-red-700 bg-red-50 focus:border-red-50 ${base}`;
    } else if (
      passwordStepperForm.formState.errors.confirmPassword === undefined &&
      dirtyFields.confirmPassword === true
    ) {
      return `text-green-500 bg-green-50 focus:border-green-50 ${base}`;
    } else {
      return base;
    }
  };
  const access_token = localStorage.getItem("access_token");

  const onSubmitPasswordSetter = async () => {
    try {
      setIsButtonDisabled(true);
      const response = await axiosPrivate.post(
        isForgetPassword ? FORGET_CHANGE_PASSWORD : PASSWORD_SETTER_URL,
        JSON.stringify({
          new_password: watchedPassword,
          confirm_password: watchedConfirmPassword,
          otp_ticket: isForgetPassword && otp_ticket,
        }),
        isForgetPassword
          ? {
              headers: {
                // prettier-ignore
                "accept": "application/json",
                // prettier-ignore
                // "Authorization": `Bearer ${access_token}`,
              },
              withCredentials: true,
            }
          : {
              headers: {
                // prettier-ignore
                "accept": "application/json",
                // prettier-ignore
                "Authorization": `Bearer ${access_token}`,
              },
              withCredentials: true,
            }
      );
      if (response?.status >= 200 && response.status < 300) {
        if (isForgetPassword) {
          goToMainLoginModal();
        } else {
          const response = await axiosPrivate.get(USER_HOME_CONTEXT, {
            headers: {
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
              // prettier-ignore
              "accept": "application/json",
            },
          });
          if (response?.status >= 200 && response.status < 300) {
            localStorage.setItem(
              "user_state",
              response?.data?.data?.user_state
            );
            setEnteredUser(
              response?.data?.data?.user_state === "REGISTERED" ||
                localStorage.getItem("user_state") === "VERIFIED"
                ? true
                : false
            );
          }
        }
      }

      if (!isForgetPassword) {
        closeModal();
        if (navigateHere) {
          if (response?.status >= 200 && response.status < 300) {
            const response = await axiosPrivate.get(USER_HOME_CONTEXT, {
              headers: {
                // prettier-ignore
                "Authorization": `Bearer ${access_token}`,
                // prettier-ignore
                "accept": "application/json",
              },
            });
          }
          navigate(navigateHere);
        } else {
          if (response?.status >= 200 && response.status < 300) {
            const response = await axiosPrivate.get(USER_HOME_CONTEXT, {
              headers: {
                // prettier-ignore
                "Authorization": `Bearer ${access_token}`,
                // prettier-ignore
                "accept": "application/json",
              },
            });
          }
          closeModal();
        }
        const body = document.querySelector("body");
        if (body) {
          body.classList.remove("overflow-hidden");
        }
      }
    } catch (error) {
      console.error(error);
      setIsButtonDisabled(false);
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const handleSubmitForm = async () => {
    if (isPasswordValid) {
      onSubmitPasswordSetter();
    } else {
    }
  };
  return (
    <>
      <div className=" flex items-end justify-start rounded-t pl-3 pt-2">
        <button
          type="button"
          onClick={closeModalNotSetPassword}
          className="text-gray-700 bg-transparent rounded-lg w-8 h-8 ms-auto inline-flex justify-end items-center  "
        >
          <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close modal</span>
        </button>
      </div>
      <form onSubmit={handleSubmit(handleSubmitForm)}>
        <div className="flex w-full pt-1 pl-8 pr-8 pb-8 flex-col items-center gap-6 self-stretch  ">
          <p className="block text-center text-gray-900 text-Title/20/Bold ">
            {isForgetPassword
              ? "رمز عبور جدید خود را وارد نمایید"
              : "انتخاب رمز عبور"}
          </p>

          <div className="flex w-full p-0 flex-col items-end gap-2 shrink-0">
            <label
              className=" w-full shrink-0 self-stretch text-gray-900 text-right text-Body-OneLine/14/Regular"
              htmlFor="password"
            >
              رمز عبور
            </label>
            <div className={getPasswordClass()}>
              <div className=" flex p-0 items-center gap-2.5 flex-1">
                <img
                  onClick={() => setPasswordShow(!passwordShow)}
                  src={`${
                    passwordShow
                      ? `/icons/eye-outline.svg`
                      : `/icons/eye-slash-outline.svg`
                  }`}
                  alt="eye"
                />
                <input
                  style={{ direction: "ltr" }}
                  {...passwordStepperForm.register("password", {
                    required: "password needed",
                    validate: {
                      justEnglish: (fieldVAlue) => {
                        return (
                          /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]+$/.test(
                            fieldVAlue
                          ) || "just english keyboard is valid"
                        );
                      },
                      moreThan8: (fieldValue) => {
                        return (
                          /^.{8,}$/.test(fieldValue) ||
                          "need 8 or more than 8 character"
                        );
                      },
                      upperAndLower: (filedValue) => {
                        return (
                          /^(?=.*[a-z])(?=.*[A-Z]).*$/.test(filedValue) ||
                          "uppercase and lowercase character needed"
                        );
                      },
                      oneNumberOrMore: (fieldValue) => {
                        return (
                          /^(?=.*[0-9]).+$/.test(fieldValue) ||
                          "one or more number needed"
                        );
                      },
                      oneOrMoreSpechialChar: (fieldValue) => {
                        return (
                          /^(?=.*[!@#$%]).+$/.test(fieldValue) ||
                          "one or more spechial character needed"
                        );
                      },
                    },
                  })}
                  className={getPasswordTextClass()}
                  id="password"
                  type={`${passwordShow ? `text` : `password`}`}
                />

                <img src="/icons/lock-outline.svg" alt="lock" />
              </div>
            </div>
          </div>

          <div className="flex w-full p-0 flex-col items-end gap-2 shrink-0">
            <label
              className=" w-full shrink-0 self-stretch text-gray-900 text-right text-Body-OneLine/14/Regular"
              htmlFor="password"
            >
              تکرار رمز عبور
            </label>
            <div className={getConfirmPasswordClass()}>
              <div className=" flex p-0 items-center gap-2.5 flex-1">
                <img
                  onClick={() => setPasswordConfShow(!passwordConfShow)}
                  src={`${
                    passwordConfShow
                      ? `/icons/eye-outline.svg`
                      : `/icons/eye-slash-outline.svg`
                  }`}
                  alt="eye"
                />
                <input
                  style={{ direction: "ltr" }}
                  id="confirmpassword"
                  {...passwordStepperForm.register("confirmPassword", {
                    validate: {
                      isSame: (fieldValue) => {
                        return (
                          fieldValue ===
                            passwordStepperForm.watch("password") ||
                          "تکرار رمز عبور یکسان نیست"
                        );
                      },
                    },
                  })}
                  className={getConfirmPasswordTextClass()}
                  type={`${passwordConfShow ? `text` : `password`}`}
                />
                <img src="/icons/lock-outline.svg" alt="lock" />
              </div>
            </div>
            <div className="flex w-full content-start items-start gap-2.5 flex-col">
              <p
                className={`${moreThan8} text-gray-600 ${
                  passwordStepperForm.formState.errors.confirmPassword ===
                  undefined
                    ? `mt-0`
                    : `mt-0`
                } text-right text-HelpText/11/Regular`}
              >
                -حداقل ۸ کاراکتر انتخاب کنید
              </p>
              <p
                className={`${upperAndLower} text-gray-600 text-right text-HelpText/11/Regular`}
              >
                -حروف بزرگ و کوچک
              </p>
              <p
                className={`${oneNumberOrMore} text-gray-600 text-right text-HelpText/11/Regular`}
              >
                -حداقل یک عدد
              </p>
              <p
                className={`${oneOrMoreSpechialChar} text-gray-600 flex h-4 flex-col content-center shrink-0 text-right text-HelpText/11/Regular`}
              >
                -حداقل یک کاراکتر مثل % $ # @ !
              </p>
              <div
                className={`${
                  watch("password") !== watch("confirmPassword") &&
                  watch("confirmPassword") !== ""
                    ? `visible`
                    : `invisible`
                } `}
              >
                <p className=" text-right text-red-500 text-Body-OneLine/14/Regular ">
                  تکرار رمز عبور یکسان نیست
                </p>
              </div>
            </div>
          </div>

          <ButtonComponent
            disabled={isButtonDisabled}
            isClicked={isButtonDisabled}
            type="submit"
            variant="filled"
            className="w-full h-[40px]"
          >
            تایید
          </ButtonComponent>
        </div>
      </form>
    </>
  );
};

export default NewPasswordSetter;
